import React, { cloneElement, FC, ReactElement } from 'react';

import { IScopeRuleUIFormat } from '../../../../interfaces/ScopeRuleUIFormat';
import { SCOPE_TYPES } from '../../../../types/scope/ScopeTypes';
import { IssueSeveritiesRuleRow } from '../scope-rule-row/IssueSeveritiesRuleRow';
import { IssueTypesRuleRow } from '../scope-rule-row/IssueTypesRuleRow';
import { UrlRuleRow } from '../scope-rule-row/UrlRuleRow';

import { IScopeRuleRowProps, IScopeRulesListProps } from './ScopeRulesList.types';

const SCOPE_RULE_ROWS: Partial<Record<SCOPE_TYPES, ReactElement<IScopeRuleRowProps>>> = {
	[SCOPE_TYPES.URL]: <UrlRuleRow />,
	[SCOPE_TYPES.ISSUE_TYPES]: <IssueTypesRuleRow />,
	[SCOPE_TYPES.ISSUE_SEVERITIES]: <IssueSeveritiesRuleRow />
};

export const ScopeRulesList: FC<IScopeRulesListProps> = ({
	rulesList,
	issueTypesList,
	issueSeveritiesList,
	onRemove,
	onRuleChange
}) => {
	return (
		<>
			{rulesList?.map((rule: IScopeRuleUIFormat) => {
				const ruleRow = SCOPE_RULE_ROWS[rule?.scopeType];

				return ruleRow
					? cloneElement(ruleRow, {
							key: rule.id,
							rule,
							issueTypesList,
							issueSeveritiesList,
							onRuleChange,
							onRemove: () => onRemove(rule.id)
						})
					: null;
			})}
		</>
	);
};
